module.exports = __webpack_public_path__ + "img/logo9.964d2864.png";